<template>
  <a-card :bordered='false'>
    <a-table :pagination='false' :scroll="{ x: 500, y: 400 }" :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class='tableFixBox'>
    </a-table>
    <!-- <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" /> -->
  </a-card>
</template>
<script>
import {} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { detailcontractingtask } from "@/api/guide";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  props: {
    id: {
      type: Number,
    },
    range_type: {
      type: Number || String,
    },
  },
  components: {},
  setup(props) {
    console.log(props.id);
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 0,
      columns: [],
    });
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    const initData = async () => {
      state.listLoading = true;
      if (props.range_type == 2) {
        state.columns = [
          {
            title: "门店编号",
            dataIndex: "store_code",
            key: "store_code",
          },
          {
            title: "门店名称",
            dataIndex: "store_name",
            key: "store_name",
          },
          {
            title: "门店类型",
            dataIndex: "type_name",
            key: "type_name",
          },
          {
            title: "联系人",
            dataIndex: "clerk_name",
            key: "clerk_name",
          },
          {
            title: "手机号码",
            dataIndex: "clerk_phone",
            key: "clerk_phone",
            customRender: ({ record }) => {
              return record.clerk_phone ? record.clerk_phone : "-";
            },
          },
          {
            title: "签约任务量",
            dataIndex: "task_number",
            key: "task_number",
          },
        ];
      } else {
        state.columns = [
          {
            title: "经销商编号",
            dataIndex: "dealer_sn",
            key: "dealer_sn",
          },
          {
            title: "经销商名称",
            dataIndex: "dealer_name",
            key: "dealer_name",
          },
          {
            title: "经销商级别",
            dataIndex: "level_name",
            key: "level_name",
          },
          {
            title: "联系人",
            dataIndex: "leader_name",
            key: "leader_name",
          },
          {
            title: "手机号码",
            dataIndex: "leader_phone",
            key: "leader_phone",
          },
          {
            title: "签约任务量",
            dataIndex: "task_number",
            key: "task_number",
          },
        ];
      }
      let res = await detailcontractingtask({ ...search.value, id: props.id })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data ? res.data.data : [];
        state.total = res.data.total;
      } else {
        message.error(res.message);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      data,
      //   columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
    };
  },
};
</script>
<style>
</style>